// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import stars02Icon from "@/assets/icons/stars-02.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type Stars02IconProps = Omit<IconProps, "name">;

export function Stars02Icon(props: Stars02IconProps): React.ReactNode {
  return <Icon name={stars02Icon} {...props} />;
}
